import { CONSIDER_COMPLETE, CONSIDER_INTERNAL_EXTERNAL, LIMIT_TO_SPEND, COE, COMMERCIAL_CLASS } from './../../model/internal-filter.model';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { DateTimeAdapter, OwlDateTimeComponent, OwlDateTimeFormats, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time-adapter.class';
import { forkJoin } from 'rxjs';
import { SCORECARD_CLASS } from '../../model/internal-filter.model';
import { INTERNALREPORT, MatSelectModel } from '../../model/score-card.model';
import { Spinner } from './../../../core/services/spinner.service';
import { VIEW_TYPE } from './../../../modules/home/components/srm/score-card/index';
import { ScoreCardService } from './../../service/score-card.service';

const moment = (_moment as any).default ? (_moment as any).default : _moment;
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const MY_MOMENT_DATE_TIME_FORMATS: OwlDateTimeFormats = {
  parseInput: 'MM/YYYY',
  fullPickerInput: 'l LT',
  datePickerInput: 'MMM/YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};
@Component({
  selector: 'app-internal-filter-dialog',
  templateUrl: './internal-filter-dialog.component.html',
  styleUrls: ['./internal-filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },

    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_DATE_TIME_FORMATS },
  ]
})
export class InternalFilterDialogComponent implements OnInit {


  dateTime: FormControl;
  currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
  commodities: MatSelectModel[] = [];
  listCommodity: MatSelectModel[] = [];
  locations: MatSelectModel[] = [];
  listLocation: MatSelectModel[] = [];
  regions: MatSelectModel[] = [];
  listRegion: MatSelectModel[] = [];
  listParentSupplierGSL: any[] = [];
  parentNameGSLs: any[] = [];
  considerParentSupplier = true;
  considerSupplierCommodity = true;
  timeRange = '4';
  reset = false;
  groupLocationAndRegion: any[] = [];
  defaultAll = true;
  gslSelected: any;
  parentNames: MatSelectModel[] = [];
  parents: any[] = [];
  gslNumbers: any[] = [];

  scorecardClasses = SCORECARD_CLASS;
  considerInternalExternals = CONSIDER_INTERNAL_EXTERNAL;
  considerCompletes = CONSIDER_COMPLETE;
  limitToSpend = LIMIT_TO_SPEND;
  coes = COE;
  commercialClasses = COMMERCIAL_CLASS;
  minors: MatSelectModel[] = [];

  scorecardClass: MatSelectModel[] = [];
  commercialClass: MatSelectModel[] = [];
  considerInternalExternal: MatSelectModel[] = [];
  coe: MatSelectModel[] = [];
  considerComplete: MatSelectModel[] = [];
  minorComponent: MatSelectModel[] = [];

  topTotalSpend = 0;

  oldParents: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<InternalFilterDialogComponent>,
    private scoreCardService: ScoreCardService,
    private spinner: Spinner,
    private cd: ChangeDetectorRef
  ) {
    this.dialogRef.disableClose = true;
    this.dateTime = new FormControl(moment());
  }

  async ngOnInit() {
    if (this.data.filteredData) {
      // data
      this.parentNames = this.data.filteredData.data.parentName ? this.data.filteredData.data.parentName : [];
      this.minors = this.data.filteredData.data.minor ? this.data.filteredData.data.minor : [];
      this.gslNumbers = this.data.filteredData.data.GSLs ? this.data.filteredData.data.GSLs : [];
      this.scorecardClasses = SCORECARD_CLASS;
      this.considerInternalExternals = CONSIDER_INTERNAL_EXTERNAL;
      this.considerCompletes = CONSIDER_COMPLETE;
      this.coes = COE;
      this.commercialClasses = COMMERCIAL_CLASS;
      this.listCommodity = this.data.filteredData.data.listCommodity ? this.data.filteredData.data.listCommodity : [];
      this.listLocation = this.data.filteredData.data.listLocation ? this.data.filteredData.data.listLocation : [];
      this.listRegion = this.data.filteredData.data.listRegion ? this.data.filteredData.data.listRegion : [];
      this.listParentSupplierGSL = this.data.filteredData.data.listParentSupplierGSL ? this.data.filteredData.data.listParentSupplierGSL
        : [];

      this.defaultAll = false;
      this.reset = false;

      // value
      this.considerParentSupplier = this.data.filteredData.value.considerParentSupplier;
      this.considerSupplierCommodity = this.data.filteredData.value.considerSupplierCommodity ? true : false;
      this.timeRange = this.data.filteredData.value.timeRange.slice();
      this.parents = this.data.filteredData.value.parents.length === 0 && this.data.firstTime ?
      this.data.filteredData.data.parentName : this.data.filteredData.value.parents;
      if (this.data.filteredData.value.gsl.length === 0 && this.data.firstTime) {
        await this.getGSL(this.parents);
      } else {
        this.parentNameGSLs = this.data.filteredData.value.gsl;
      }
      this.oldParents = this.parents.slice();
      this.commodities = this.data.filteredData.value.commodities.length > 0 ?
        this.data.filteredData.value.commodities : [];
      this.locations = this.data.filteredData.value.locations.length > 0 ? this.data.filteredData.value.locations : [];
      this.regions = this.data.filteredData.value.regions.length > 0 ? this.data.filteredData.value.regions : [];
      this.scorecardClass = this.data.filteredData.value.scorecardClass.length > 0 ? this.data.filteredData.value.scorecardClass
        : SCORECARD_CLASS;
      this.commercialClass = this.data.filteredData.value.commercialClass.length > 0 ? this.data.filteredData.value.commercialClass
        : COMMERCIAL_CLASS;
      this.considerInternalExternal = this.data.filteredData.value.considerInternalExternal.length > 0
        ? this.data.filteredData.value.considerInternalExternal : [CONSIDER_INTERNAL_EXTERNAL[1]];
      this.coe = this.data.filteredData.value.coe.length > 0 ? this.data.filteredData.value.coe
        : COE;
      this.considerComplete = this.data.filteredData.value.considerComplete.length > 0 ? this.data.filteredData.value.considerComplete
        : this.considerCompletes;
      this.minorComponent = this.data.filteredData.value.minorComponent.length > 0 ?
        this.data.filteredData.value.minorComponent : this.minors;
      this.dateTime = this.data.filteredData.value.poReceiptMonth ? new FormControl(moment(this.data.filteredData.value.poReceiptMonth))
        : new FormControl(moment(this.data.poReceiptMonthDefault));
      this.topTotalSpend = this.data.filteredData.value.topTotalSpend ? this.data.filteredData.value.topTotalSpend : 0;

    } else {
      this.scorecardClass = this.scorecardClasses;
      this.commercialClass = this.commercialClasses;
      this.considerInternalExternal = this.considerInternalExternals;
      this.coe = this.coes;
      this.considerComplete = this.considerCompletes;
    }
    if (this.listCommodity.length === 0) {
      this.getDataFilter();
    }
  }

  public timeRangeChanged() {
    this.getDataFilter();
  }

  private getDataFilter() {
    if (this.timeRange && this.dateTime) {
      const date = new Date(this.dateTime.value.format()).getTime();
      // const gsl = Object.values(this.parentNameGSLs).map((item) => item.value);
      const gsl = this.parentNameGSLs.map((item) => item.value);
      const parents = gsl.length === 0 && this.parents.length > 0 ? this.parents.map(item => item.value) : [];
      forkJoin(
        this.scoreCardService.getCommodities(gsl, this.timeRange, date, VIEW_TYPE.TABLE, parents),
        this.scoreCardService.getLocationsAndRegions(gsl, this.timeRange, date, VIEW_TYPE.TABLE, parents)
      ).subscribe(result => {
        // mapping commodities
        const commodityArray = result[0].data.map(item => {
          const object = {
            name: item.name,
            value: item.name
          } as MatSelectModel;
          return object;
        });
        this.listCommodity = commodityArray;
        this.commodities = this.listCommodity;

        // mapping location-region
        // if (result[1].data.length > 0) {
        this.groupLocationAndRegion = result[1].data;
        // map array object locations
        const locationArray = this.groupLocationAndRegion.map(item => item.location).filter(this.onlyUnique)
          .map(item => ({ name: item, value: item } as MatSelectModel));
        this.listLocation = locationArray;
        this.locations = this.listLocation;
        // }

        // map array object region
        const regionArray = this.groupLocationAndRegion.map(item => item.region).filter(this.onlyUnique)
          .map(item => ({ name: item, value: item } as MatSelectModel));
        this.listRegion = regionArray;
        this.regions = this.listRegion;

        this.cd.detectChanges();
      });
    }
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  public async getGSL(value) {
    this.parents = value.slice();
    if (this.parents[0] === 'All') {
      this.parents.shift();
    }

    const newParents = this.parents.filter(item => {
      return this.oldParents.filter(item2 => {
        return item.value === item2.value;
      }).length === 0;
    });
    this.oldParents = this.parents.slice();
    // this.parents = data.map(item => item.value);
    const result = await this.scoreCardService.getGSLsByParent(this.parents.map(item => item.value)).toPromise();
    if (result.data.length > 0) {
      this.gslNumbers = result.data.map(item => ({
        name: `${item.s}/${item.g}`,
        value: item.g,
        parentName: item.p,
        suplierName: `${item.s}/${item.g}`
      }));

      if (newParents.length > 0) {
        newParents.forEach(item => {
          this.parentNameGSLs.push(...this.gslNumbers.filter(item2 => item.value === item2.parentName));
        });
      }

      if (this.parentNameGSLs.length > 0) {
        const gslNumbers = [];
        this.parents.forEach(item => {
          gslNumbers.push(...this.parentNameGSLs.filter(gsl => gsl.parentName === item.value));
        });
        this.parentNameGSLs = gslNumbers;
      }
      this.getDataFilter();
      this.cd.detectChanges();
    } else {
      this.gslNumbers = [];
      this.parentNameGSLs = [];
      this.cd.detectChanges();
    }
  }


  filterData(name, value) {
    if (name === 'parentSupplier') {
      // list parent name
      this.parentNameGSLs = value;
      this.getDataFilter();
      return;
    }
    const data = value.slice();
    if (data[0] === 'All') {
      data.shift();
    }
    switch (name) {
      case 'location':
        this.locations = data;
        break;
      case 'gslNumber':
        this.parentNameGSLs = data;
        this.getDataFilter();
        break;
      case 'scorecard':
        this.scorecardClass = data;
        break;
      case 'commodity':
        this.commodities = data;
        break;
      case 'region':
        this.regions = data;
        break;
      case 'commercial':
        this.commercialClass = data;
        break;
      case 'minor':
        this.minorComponent = data;
        break;
      case 'coe':
        this.coe = data;
        break;
      case 'considerInternalExternal':
        this.considerInternalExternal = data;
        break;
      case 'considerComplete':
        this.considerComplete = data;
        break;
      default:
        return;
    }
  }

  resetFilter() {
    this.reset = true;
    this.considerParentSupplier = true;
    this.considerSupplierCommodity = true;
    this.timeRange = '4';
    this.oldParents = [];
    this.parentNameGSLs = [];
    this.scorecardClass = this.scorecardClasses;
    this.commercialClass = this.commercialClasses;
    this.considerInternalExternal = [CONSIDER_INTERNAL_EXTERNAL[1]];
    this.coe = this.coes;
    this.considerComplete = this.considerCompletes;
    this.minorComponent = this.minors;
    this.parents = this.data.filteredData.data.parentName;
    this.dateTime = new FormControl(moment(this.data.poReceiptMonth));
    this.getGSL(this.parents);
    this.topTotalSpend = 0;
    this.reset = true;
    setTimeout(() => {
      this.reset = false;
    }, 1000);
  }

  apply() {
    if (this.checkDisabledApplyButton()) {
      this.dialogRef.close({
        value: {
          // gsl: Object.assign({}, this.parentNameGSLs),
          parents: this.parents.slice(),
          gsl: this.parentNameGSLs.slice(),
          locations: this.locations.slice(),
          commodities: this.commodities.slice(),
          regions: this.regions.slice(),
          considerParentSupplier: this.considerParentSupplier.valueOf(),
          considerSupplierCommodity: this.considerSupplierCommodity.valueOf(),
          timeRange: this.timeRange.slice(),
          poReceiptMonth: new Date(this.dateTime.value.format()).getTime(),
          scorecardClass: this.scorecardClass.slice(),
          commercialClass: this.commercialClass.slice(),
          considerInternalExternal: this.considerInternalExternal.slice(),
          coe: this.coe.slice(),
          considerComplete: this.considerComplete.slice(),
          minorComponent: this.minorComponent.slice(),
          topTotalSpend: this.topTotalSpend
        } as INTERNALREPORT,
        data: {
          listCommodity: this.listCommodity.slice(),
          listLocation: this.listLocation.slice(),
          listRegion: this.listRegion.slice(),
          // listParentSupplierGSL: this.listParentSupplierGSL.slice(),
          parentName: this.parentNames.slice(),
          GSLs: this.gslNumbers.slice(),
          scorecardClasses: this.scorecardClasses.slice(),
          considerInternalExternals: this.considerInternalExternals.slice(),
          considerCompletes: this.considerCompletes.slice(),
          coes: this.coes.slice(),
          commercialClasses: this.commercialClasses.slice(),
          minor: this.minors.slice(),
        }
      });
      this.cd.detectChanges();
    }
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: OwlDateTimeComponent<Moment>) {
    const ctrlValue = this.dateTime.value;
    ctrlValue.month(normalizedMonth.month());
    this.dateTime.setValue(ctrlValue);
    datepicker.close();
    this.getDataFilter();
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.dateTime.value;
    ctrlValue.year(normalizedYear.year());
    this.dateTime.setValue(ctrlValue);
  }

  checkDisabledApplyButton() {
    return this.locations.length > 0 && this.commodities.length > 0
      && this.regions.length > 0 && this.scorecardClass.length > 0
      && this.considerComplete.length > 0 && this.considerInternalExternal.length > 0
      && this.minorComponent.length > 0 && this.coe.length > 0;
  }

}
